import { matcher, MatchType } from "@cdv/jazz-ui";
import View from "../ui/View";
import Content from "./Content";
import { Resource } from "../utils";

export default matcher({ resource: Resource.User })
  .set(MatchType.View, View)
  .set(MatchType.Content, Content)
  .entries();
